import React from "react";

// interruptor acessível (role="switch"); o próprio componente é o botão clicável
export default function AdminSwitch({ on, onClick, disabled = false, label, className = "" }: { on: boolean | undefined, onClick: () => void, disabled?: boolean, label?: React.ReactNode, className?: string }) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={!!on}
            disabled={disabled}
            onClick={onClick}
            className={`group inline-flex items-center gap-3 text-sm font-semibold text-gray-700 disabled:cursor-not-allowed disabled:opacity-60 focus:outline-none ${className}`}
        >
            <span className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors group-focus-visible:ring-2 group-focus-visible:ring-secondary group-focus-visible:ring-offset-2 ${on ? "bg-emerald-500" : "bg-gray-300"}`}>
                <span className={`inline-block h-5 w-5 rounded-full bg-white shadow transition-transform ${on ? "translate-x-[22px]" : "translate-x-0.5"}`} />
            </span>
            {
                label ?
                    <span>{label}</span>
                    : null
            }
        </button>
    )
}
